export default __webpack_public_path__ + "static/media/chipi.5345c783.png";